export default __webpack_public_path__ + "static/media/tree.5b15ec7e.svg";